import { getUseResource } from '../resource';
import { productResources } from '../builders/productResources';
import { IAdminProductsResponse, IProductsResponse } from '../../models/ProductsResponse';
import { Single } from '../../types/single';

interface IAdminProductMutationResponse {
  status: number;
  message: string;
  data: {
    id: string;
    legacyId: number | null;
    name: string;
    stripeProductId: string;
  };
}

const mapProductMutationResponse = (body: IAdminProductMutationResponse): Single<IProductsResponse['products']> => ({
  id: body.data.id,
  legacyId: body.data.legacyId,
  name: body.data.name,
  stripeProductId: body.data.stripeProductId,
  created: 0,
  packages: [],
});

/** Request all products at once — consumers (tabs, selects, grids) expect the full list. */
const getProductsQueryParams = () => ({ page: 1, page_size: 1000 });

export const apiProduct = {
  useGetProducts: getUseResource(
    productResources.getProducts,
    (body: IAdminProductsResponse): IProductsResponse => ({
      products: body.data.data.map((product) => ({
        id: product.id,
        legacyId: product.legacyId,
        name: product.name,
        stripeProductId: product.stripeProductId,
        created: new Date(product.createdAt).getTime(),
        updated: new Date(product.updatedAt).getTime(),
        packages: product.packages,
      })),
    }),
    getProductsQueryParams
  ),
  useCreateProduct: getUseResource(
    productResources.createProduct,
    mapProductMutationResponse,
    (params, payload: { name: string; installerPath: string; docsPath: string; packages: string[] }) => ({
      name: payload.name,
      installerPath: payload.installerPath,
      docsPath: payload.docsPath,
      packages: payload.packages,
    })
  ),
  useUpdateProduct: getUseResource(
    productResources.updateProduct,
    mapProductMutationResponse,
    (params, payload: { name: string; packages: string[] }) => ({
      name: payload.name,
      packages: payload.packages,
    })
  ),
  useDeleteProduct: getUseResource(productResources.deleteProduct, () => null),
};
